import React, { PureComponent } from 'react';
import styled, { css } from 'react-emotion';
import { fontSize, lineHeight, mq } from '../../../css';

export default class Partner extends PureComponent {
    constructor() {
        super();
        this.state = {
            visible: false,
        };
        this.toggleText = this.toggleText.bind(this);
    }

    toggleText() {
        this.setState(prevState => ({
            visible: !prevState.visible,
        }));
    }

    render() {
        const { content, image, title } = this.props;
        const { visible } = this.state;
        return (
            <s.partner>
                <s.partnerImage onClick={this.toggleText}>
                    <img src={image} alt={title} />
                </s.partnerImage>
                {visible && <s.partnerText>{content}</s.partnerText>}
            </s.partner>
        );
    }
}

const s = {};

s.partner = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    ${mq({
        width: ['100%', '50%', '50%', '25%'],
    })};
    img {
        align-self: center;
        margin-bottom: 20px;
        width: 200px;
        ${mq({
            width: [100, 120, 200],
        })};
    }
`;

s.partnerImage = styled.div`
    min-height: 180px;
    display: flex;
    justify-content: center;
`;

s.partnerText = styled.div`
    padding: 20px;
    display block;
     p {
        font-size: ${fontSize(12)};
        line-height: ${lineHeight(24, 16)};
    }
`;



// WEBPACK FOOTER //
// ./src/components/sections/partners/partner.component.js